module.exports = __webpack_public_path__ + "static/media/decibel-insight-knowledgebase.046dc61c.md";